<template>
    <div class="invisible-button" @click="handleClick"></div>
</template>
  
<script>
export default {
    name: 'InvisibleButton',
    data() {
        return {
            clickCount: 0,
            lastClickTimestamp: null,
        };
    },
    methods: {
        handleClick() {
            const currentTime = new Date().getTime();
            if (
                this.lastClickTimestamp === null ||
                currentTime - this.lastClickTimestamp > 5000
            ) {
                this.clickCount = 1;
                this.lastClickTimestamp = currentTime;
            } else {
                this.clickCount++;
                this.lastClickTimestamp = currentTime;
                if (this.clickCount === 3) {
                    this.clearLocalStorage();
                    this.clickCount = 0;
                }
            }
        },
        clearLocalStorage() {
            localStorage.clear();
            console.log('Local storage cleared');
            let currentPage = location.href;
            location.href = currentPage;
        },
    },
};
</script>
  
<style scoped>
.invisible-button {
    position: fixed;
    bottom: 0;
    left: 0;
    width: 50px;
    height: 50px;
    z-index: 1000;
    cursor: pointer;
}
</style>
  